import Vue from 'vue'
import BTextField from '@/components/global_components/BTextField'
import BCheckbox from '@/components/global_components/BCheckbox'
import BReadOnlyTextField from '@/components/global_components/BReadOnlyTextField'
import BCard from '@/components/global_components/BCard'
import BSelect from '@/components/global_components/forms/BSelect'
import BComboBox from '@/components/global_components/combobox/BComboBox'
import BTextArea from '@/components/global_components/forms/BTextArea'
import BDateField from '@/components/global_components/forms/BDateField'
import BAutocomplete from '@/components/global_components/forms/BAutocomplete'
import BToggleableContent from '@/components/global_components/forms/BToggleableContent'
import BUploadZone from '@/components/global_components/forms/BUploadZone'
import BTabs from '@/components/global_components/BTabs'
import BUnit from '@/components/global_components/BUnit'
import BColumn from '@/components/global_components/BColumn'
import BRow from '@/components/global_components/BRow'
import BDataTable from '@/components/base_components/tables/BDataTable'
import BHeaderPicker from '@/components/global_components/BHeaderPicker'
import BButton from "@/components/global_components/BButton"
import BRadio from "@/components/global_components/forms/BRadio";
// import BTab from '@/components/global_components/BTab'
// import buttons from '@/components/global_components/buttons.js'

Vue.component('b-text-field', BTextField)
Vue.component('b-read-only-text-field', BReadOnlyTextField)
Vue.component('b-btn', BButton)
Vue.component('b-check-box', BCheckbox)
Vue.component('b-radio', BRadio)
Vue.component('b-card', BCard)
Vue.component('b-select', BSelect)
Vue.component('b-combo-box', BComboBox)
Vue.component('b-text-area', BTextArea)
Vue.component('b-date-field', BDateField)
Vue.component('b-autocomplete', BAutocomplete)
Vue.component('b-toggleable-content', BToggleableContent)
Vue.component('b-tabs', BTabs)
// Vue.component('b-tab', BTab)
Vue.component('b-unit', BUnit)
Vue.component('b-column', BColumn)
Vue.component('b-row', BRow)
Vue.component('b-upload-zone', BUploadZone)
Vue.component('b-data-table', BDataTable)
Vue.component('b-header-picker', BHeaderPicker)
